<script setup lang="ts">
import { PtwCommentDto } from '@/api/generator';
import { mdiPlus } from '@mdi/js';
import { edit } from '@/components/icons/icons';
import DateTimeFormatter from '@/components/formatters/DateTimeFormatter.vue';
import IdentifierLabel from '@/components/IdentifierLabel/IdentifierLabel.vue';

interface CommentMetaInfoProps {
  commentDto: PtwCommentDto;
}

enum Mode {
  ShowCreated = 'showCreated',
  ShowEdited = 'showEdited',
}

const { commentDto } = defineProps<CommentMetaInfoProps>();

const mode = commentDto.lastModificationTime ? Mode.ShowEdited : Mode.ShowCreated;
const user = mode === Mode.ShowEdited ? commentDto.lastModifierUser : commentDto.creatorUser;
const timestamp =
  mode === Mode.ShowEdited ? commentDto.lastModificationTime : commentDto.creationTime;
</script>

<template>
  <div class="container text-body-2">
    <v-icon
      class="icon"
      :icon="mode === Mode.ShowEdited ? edit : mdiPlus"
      data-testid="comment_metaInfo_icon"
      :mode="mode"
    />
    <div class="date-and-time" data-testid="comment_metaInfo_date">
      <DateTimeFormatter :value="timestamp" />
    </div>
    <IdentifierLabel v-if="user" :label="user.fullName" :identifier="user.iuid" />
  </div>
</template>

<style scoped lang="scss">
.container {
  display: flex;
  color: rgb(var(--v-theme-primary));
  align-items: center;
}

.icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
}

.date-and-time {
  margin-right: 8px;
  font-weight: 500;
  flex-shrink: 0;
}
</style>
